var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.AuthLayout,
    [
      _c(_setup.AuthCardHeader, { attrs: { title: "Forgot your password?" } }),
      _vm._v(" "),
      !_setup.sent
        ? _c(_setup.ValidationObserver, {
            attrs: { slim: "" },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function ({ handleSubmit }) {
                    return [
                      _c(
                        "form",
                        {
                          staticClass: "forgot-form",
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                              return handleSubmit(_setup.submit)
                            },
                          },
                        },
                        [
                          _c("p", { staticClass: "forgot-intro" }, [
                            _vm._v(
                              "\n                Enter your user account's verified email address and we will send you a password reset link.\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(_setup.ValidationProvider, {
                            attrs: { rules: "required|email", name: "Email" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c(_setup.CInput, {
                                        attrs: {
                                          type: "email",
                                          label: "Email",
                                          placeholder: "Type your email",
                                          error: !!errors[0],
                                          "error-msg": errors[0],
                                        },
                                        model: {
                                          value: _setup.email,
                                          callback: function ($$v) {
                                            _setup.email = $$v
                                          },
                                          expression: "email",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                          _vm._v(" "),
                          _setup.errorMessage
                            ? _c(_setup.CError, {
                                attrs: { message: _setup.errorMessage },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c(_setup.CButton, {
                            staticClass: "w-100",
                            attrs: {
                              type: "submit",
                              variant: "primary",
                              text: _setup.sending
                                ? "Sending..."
                                : "Send password reset email",
                              disabled: _setup.sending,
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ],
              null,
              false,
              3442165456
            ),
          })
        : _c("p", { staticClass: "forgot-intro" }, [
            _vm._v(
              "\n        If that email belongs to a Customily account, the password reset link is on its way.\n    "
            ),
          ]),
      _vm._v(" "),
      _c("p", { staticClass: "signin-link" }, [
        _c("a", { attrs: { href: "/signin" } }, [_vm._v("Back to log in")]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }